<template>
    <div class="bg-white rounded box-shadow p-3">
        <b-modal hide-footer id="trainee-bank-modal" size="lg" :title="trainee_name + ' Bank Information'">
            <div class="row">
                <div class="alert alert-danger alert-dismissible fade show" role="alert"
                     v-if="show">
                        <span :key="index" v-for="(err, index) in validation_errors">
                          {{ err[0] }} <br/>
                        </span>
                </div>
            </div>
            <div class="modal-content bg-white rounded box-shadow">
                <div class="form-row">
                    <div class="col-md-6">
                        <label class="col-form-label col-form-label-sm" for="bank_id">Select Bank</label>
                        <select @change="getBanksAccount(bank)" v-model="bank.c_bank_id" v-validate="'required'" id="bank_id" name="bank_id" class="form-control form-control-sm" >
                            <option :value="''" selected>Select Bank</option>
                            <option v-for="(bank, index) in banks"  :key="index" v-bind:value="bank.id" >
                                {{ bank.id }} :  {{ bank.desc }}
                            </option>
                        </select>
                        <div class="invalid-feedback">
                            Please Select Bank
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="col-form-label col-form-label-sm" for="bank_id">Select Account Type</label>
                        <select v-model="bank.bank_account_type_id" v-validate="'required'" id="bank_id" name="bank_id" class="form-control form-control-sm" >
                            <option :value="null" selected>Select Account type</option>
                            <option v-for="(type, index) in account_types"  :key="index" :value="type.id" >
                                {{ type.id }} :  {{ type.account_type }}
                            </option>
                        </select>
                        <div class="invalid-feedback">
                            Please Select Bank
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label class="col-form-label col-form-label-sm" for="branch_name">Branch name</label>
                        <input type="text" v-model="bank.branch_name" v-validate="{ required: true, regex: /^[a-zA-Z\s]*$/ }"
                               id="branch_name" name="branch_name" placeholder="Branch Name"  class="form-control form-control-sm" />
                        <div class="invalid-feedback">Please provide Branch Name</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label class="col-form-label col-form-label-sm" for="account_no">Account Number</label>
                        <input type="text" v-model="bank.account_no" v-validate="{ required: true }"
                               id="account_no" name="account_no" class="form-control form-control-sm" placeholder="Account Number"/>
                        <div class="invalid-feedback">
                            Please provide Account Number
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label class="col-form-label col-form-label-sm" for="remark">Remarks</label>
                        <input type="text" v-model="bank.remark" id="remark" name="remark" class="form-control form-control-sm" placeholder="Remark"/>
                    </div>
                </div>
                <input name="trainee_id" type="hidden" v-model="bank.trainee_id"/>
                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <span v-if="userPermission.includes('bank-add')">
                            <b-button class="form-control-sm mr-2" variant="success"  @click.prevent="save" >Save</b-button>
                        </span>
                        <span v-if="userPermission.includes('bank-update')">
                            <b-button class="form-control-sm" size="sm" variant="danger" @click="$bvModal.hide('trainee-bank-modal')">Cancel</b-button>
                        </span>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        name: "traineeBank",
        props: ["trainee_id", "bank", "account_types", "trainee_name"],
        data() {
            return {
                errorMessage: "",
                status: 0,
                message: "",
                validation_errors: {},
                banks: [],
                show: false,
                // accountTypes: [{name: 'dsdsd'}],
            };
        },

        mounted() {
            this.getBanks();
        },
        created() {

        },
        methods: {
            getBanksAccount(bank){
                this.$emit('getBankTypes', bank)
            },
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.bank.trainee_id = this.trainee_id;
                        http
                            .post("api/trainee/bank/add", this.bank)
                            .then(response => {
                                if (!response.data.error) {
                                    if (response.data.permissionError) {
                                        this.$bvToast.toast(response.data.permissionError, {
                                            title: "Error",
                                            autoHideDelay: 5000,
                                            variant: "danger"
                                        });
                                    } else {
                                        this.$bvToast.toast(response.data.message, {
                                            title: "Success",
                                            autoHideDelay: 5000,
                                            variant: "success"
                                        });
                                        this.$bvModal.hide("trainee-bank-modal");
                                        this.$emit("search");
                                    }
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            update() {},
            getBanks() {
                http.get("api/trainee/bank/getBanks/").then(response => {
                    if (!response.error) {
                        this.banks = response.data.banks;
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
